


















import { Component, Vue } from "vue-property-decorator";
import headerCom from "./headerCom.vue";
import footerCom from "./footerCom.vue";
@Component({
  components: { headerCom, footerCom },
})
export default class Home extends Vue {
  public activeMenu = "";
  // public mounted() {}
}
